import { call, put, takeLatest } from "redux-saga/effects";
import {
  getLocalInfoFailure, getLocalInfoStart, getLocalInfoSuccess, getRolesFailure, getRolesStart, getRolesSuccess, getUsersFailure, getUsersStart, getUsersSuccess, setActiveGmailFailure, setActiveGmailStart, setActiveGmailSuccess, setLocalInfoFailure, setLocalInfoStart, setLocalInfoSuccess, saveJobBoardDetailsFailure, saveJobBoardDetailsSuccess, saveJobBoardDetailsStart, saveCompanyDetailsSuccess, saveCompanyDetailsFailure, saveCompanyDetailsStart, getCompanyDetailsSuccess, getCompanyDetailsFailure, getCompanyDetailsStart, organizationImageUploadSuccess,
  organizationImageUploadFailure, organizationImageUploadStart,
  getLocalRestrictionStart,
  getLocalRestrictionSuccess,
  getLocalRestrictionFailure,
  getBrandingImageStart,
  getBrandingImageSuccess,
  getBrandingImageFailure,
  getAllIntegrationsStart,
  getAllIntegrationsSuccess,
  getAllIntegrationsFailure,
  getRALocationsStart,
  getRALocationsSuccess,
  getRALocationsFailure,
    getBDMLocationsStart,
  getBDMLocationsSuccess,
  getBDMLocationsFailure,
  getRecruitmentSettingsSuccess,
  getRecruitmentSettingsFailure,
  getRecruitmentSettingsStart
} from "./settingsSlice";
import { getAllRoles, getAllUsers, getOrganizationLocaleInfo, updateOrganizationLocaleInfo, saveJoboarddetailsApi, updateOrganizationGeneralDetails, organizationImageUpload, getAllLocalRestrictionApi, getAllIntegrationAccess, getAllIntegrations, getLocationRAapi, addLocationByBDMapi, getLocationBDMapi, getAllSettingsApi } from "./settingApi";
import { showToast } from "../../../components";
import { updateOrganizationSuccess } from "../auth/authSlice";

function* setActiveGmailSaga(action) {
  try {
    const { gmail } = action.payload;

    // const response = yield call(updateActiveGmail, gmail);

    // if (response.success) {
    yield put(setActiveGmailSuccess(gmail));
  } catch (error) {
    yield put(setActiveGmailFailure(error.message));
    console.log(error.message || "Failed to set Active Gmail");
  }
}

function* getUsersSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getAllUsers, params);
    if (response?.data) {
      yield put(getUsersSuccess(response.data.data || []));
    } else {
      yield put(getUsersFailure(response.message || "Failed to fetch users"));
    }
  } catch (error) {
    yield put(getUsersFailure(error.message));
    console.error(error.message || "Failed to fetch users");
  }
}

function* getRolesSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getAllRoles, params);
    if (response?.data) {
      yield put(getRolesSuccess(response.data.data || []));
    } else {
      yield put(getRolesFailure(response.message || "Failed to fetch roles"));
    }
  } catch (error) {
    yield put(getRolesFailure(error.message));
    console.error(error.message || "Failed to fetch roles");
  }
}

function* setLocalInfoSaga(action) {
  try {
    const { id, localeInfo } = action.payload;
    const response = yield call(updateOrganizationLocaleInfo, { id, localeInfo });

    if (response?.data) {
      // yield put(setLocalInfoSuccess(response.data.data.localeInfo));
      yield put(setLocalInfoSuccess(response.data.data.locale));
      yield call(showToast, "Local Information updated successfully!", "success", 2000);
    } else {
      yield put(setLocalInfoFailure("Failed to update locale info"));
    }
  } catch (error) {
    yield put(setLocalInfoFailure(error.message));
  }
}

function* getLocalInfoSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getOrganizationLocaleInfo, params);

    const localeInfo = response?.data?.data?.localeInfo;

    if (localeInfo) {
      yield put(getLocalInfoSuccess(localeInfo));
    } else {
      yield put(getLocalInfoFailure("No locale info found"));
    }
  } catch (error) {
    yield put(getLocalInfoFailure(error.message));
  }
}

function* getBrandingImageSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getOrganizationLocaleInfo, params);

    let brandingImageData = null;

    if (response?.data?.data?.logo) {
      const companyUrl = response?.data?.data?.logo?.company;
      const socialUrl = response?.data?.data?.logo?.social;

      brandingImageData = {
        company: companyUrl,
        social: socialUrl,
      };

      // console.log("brandingImageData action", brandingImageData);
    }

    if (brandingImageData) {
      yield put(getBrandingImageSuccess(brandingImageData));
    } else {
      yield put(getBrandingImageFailure("No Image info found"));
    }
  } catch (error) {
    yield put(getBrandingImageFailure(error.message));
  }
}

function* fetchIntegrationAccessAll(params) {
    try {
        const response = yield call(getAllIntegrations, params.payload);
        const accessData = response?.data?.data || []
        yield put(getAllIntegrationsSuccess(accessData));
    } catch (error) {
        yield put(getAllIntegrationsFailure(error?.message));
    }
}


// function* saveJobBoardDetailsSaga(action) {
//   try {
//     const payload = action.payload;
//     const response = yield call(saveJoboarddetailsApi, payload);

//     if (response?.data) {
//       yield put(saveJobBoardDetailsSuccess(response.data));
//       yield call(showToast, "Job Board details saved successfully!", "success", 2000);
//     } else {
//       yield put(saveJobBoardDetailsFailure("Failed to save Job Board details"));
//     }
//   } catch (error) {
//     yield put(saveJobBoardDetailsFailure(error.message));
//     yield call(showToast, error.message || "Error saving Job Board details", "error", 2000);
//   }
// }
// function* saveJobBoardDetailsSaga(action) {
//   try {
//     const payload = action.payload;
//     const response = yield call(saveJoboarddetailsApi, payload);

//     // response.data.data contains the actual integration info
//     if (response?.data?.data) {
//       yield put(saveJobBoardDetailsSuccess(response.data.data));
//       yield call(showToast, "Job Board details saved successfully!", "success", 2000);
//     } else {
//       yield put(saveJobBoardDetailsFailure("Failed to save Job Board details"));
//       yield call(showToast, "Failed to save Job Board details", "error", 2000);
//     }
//   } catch (error) {
//     yield put(saveJobBoardDetailsFailure(error.message));
//     yield call(showToast, error.message || "Error saving Job Board details", "error", 2000);
//   }
// }

function* saveJobBoardDetailsSaga(action) {
  try {
    const payload = action.payload; // original payload sent to API
    const response = yield call(saveJoboarddetailsApi, payload);

    // Merge API response with original payload so Redux stores everything
    let integrationToStore = { ...payload.payload }; // take the payload object

    if (response?.data?.data) {
      // Add fields returned by API (like integrationId, postActionResult)
      integrationToStore = { ...integrationToStore, ...response.data.data };
      yield put(saveJobBoardDetailsSuccess(integrationToStore));
      yield call(showToast, "Job Board details saved successfully!", "success", 2000);
    } else {
      yield put(saveJobBoardDetailsFailure("Failed to save Job Board details"));
      yield call(showToast, "Failed to save Job Board details", "error", 2000);
    }
  } catch (error) {
    yield put(saveJobBoardDetailsFailure(error.message));
    yield call(showToast, error.message || "Error saving Job Board details", "error", 2000);
  }
}


function* saveCompanyDetailsSaga(action) {
  try {
    const { id, payload } = action.payload;
    const response = yield call(updateOrganizationGeneralDetails, { id, payload });

    if (response?.data?.data) {
      yield put(saveCompanyDetailsSuccess(response.data.data));
      yield put(updateOrganizationSuccess(response.data.data));
      yield call(showToast, "Company details updated successfully!", "success", 2000);
    } else {
      yield put(saveCompanyDetailsFailure("Failed to update company details"));
      yield call(showToast, "Failed to update company details", "error", 2000);
    }
  } catch (error) {
    yield put(saveCompanyDetailsFailure(error.message));
    yield call(showToast, error.message || "Error updating company details", "error", 2000);
  }
}

export function* getCompanyDetailsSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getOrganizationLocaleInfo, params);

    const generalDetails = response?.data?.data;

    if (generalDetails) {
      yield put(getCompanyDetailsSuccess(generalDetails));
      yield put(updateOrganizationSuccess(generalDetails));
    } else {
      yield put(getCompanyDetailsFailure("No general details found"));
      showToast("No general details found", "error");
    }
  } catch (error) {
    const message =
      error?.response?.data?.message || "Failed to fetch company details";
    yield put(getCompanyDetailsFailure(message));
    showToast(message, "error");
  }
}

export function* organizationImageUploadSaga(action) {
  try {
    const { file, organizationId, logoType, orgName, previousUrl } = action.payload;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("organizationId", organizationId);
    formData.append("logoType", logoType);
    formData.append("orgName", orgName);
    formData.append("uploadType", "single");
    formData.append("coll", "Organization");
    formData.append("previousUrl", previousUrl);


    const result = yield call(organizationImageUpload, formData);

    if (result?.data?.data) {
      showToast("Organization Image Uploaded successfully!", "success", 2000);
      const companyUrl = result.data.data.logo.company;
      const socialUrl = result.data.data.logo.social;

      // console.log("company logo:", companyUrl, "social logo:", socialUrl);

      const payload = {
        company: companyUrl,
        social: socialUrl,
      };

      yield put(organizationImageUploadSuccess(payload));
      
      // Update auth slice so useLoginUser() returns fresh data
      yield put(updateOrganizationSuccess({
        logo: {
          company: companyUrl,
          social: socialUrl
        }
      }));
    } else {
      showToast(result?.error || "Upload failed", "error", 3000);
      yield put(organizationImageUploadFailure(result?.error || "Upload failed"));
    }
  } catch (error) {
    console.error("organizationImageUploadSaga error:", error);
    showToast("Something went wrong during upload", "error", 3000);
    yield put(organizationImageUploadFailure(error.message));
  }
}


export function* getAllIntegrationSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getAllIntegrationAccess,params);
    const restrictions = response?.data?.data || [];
    yield put(getLocalRestrictionSuccess(restrictions));
  } catch (error) {
    yield put(getLocalRestrictionFailure(error || error.message));
  }
}

export function* getLocalRestrictionSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getAllLocalRestrictionApi,params);
    const restrictions = response?.data?.data || [];
    yield put(getLocalRestrictionSuccess(restrictions));
  } catch (error) {
    yield put(getLocalRestrictionFailure(error || error.message));
  }
}

export function* getRAAddedLocationSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getLocationRAapi,params);
 const data = response?.data?.data || [];
    yield put(getRALocationsSuccess(data));
  } catch (error) {
    yield put(getRALocationsFailure(error || error.message));
  }
}
export function* getBDMAddedLocationSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getLocationBDMapi,params);

 const data = response?.data?.data || [];
    yield put(getBDMLocationsSuccess(data));
  } catch (error) {
    yield put(getBDMLocationsFailure(error || error.message));
  }
}

function* getRecruitmentSettingsSaga(action) {
  try {
    const params = action.payload;
    const response = yield call(getAllSettingsApi,params);

    const data = response?.data?.data || [];
    yield put(getRecruitmentSettingsSuccess(data));
  } catch (error) {
    yield put(getRecruitmentSettingsFailure(error || error.message));
  }
};

export function* watchSettingSaga() {
  yield takeLatest(setActiveGmailStart.type, setActiveGmailSaga);
  yield takeLatest(getUsersStart.type, getUsersSaga);
  yield takeLatest(getRolesStart.type, getRolesSaga);
  yield takeLatest(setLocalInfoStart.type, setLocalInfoSaga);
  yield takeLatest(getLocalInfoStart.type, getLocalInfoSaga);
  yield takeLatest(saveJobBoardDetailsStart.type, saveJobBoardDetailsSaga);
  yield takeLatest(saveCompanyDetailsStart.type, saveCompanyDetailsSaga);
  yield takeLatest(getCompanyDetailsStart.type, getCompanyDetailsSaga);
  yield takeLatest(organizationImageUploadStart.type, organizationImageUploadSaga);
  yield takeLatest(getBrandingImageStart.type, getBrandingImageSaga);
  yield takeLatest(getLocalRestrictionStart.type, getLocalRestrictionSaga);
 yield takeLatest(getAllIntegrationsStart.type,fetchIntegrationAccessAll);
 yield takeLatest(getRALocationsStart.type,getRAAddedLocationSaga);
   yield takeLatest(getBDMLocationsStart.type,getBDMAddedLocationSaga);
   yield takeLatest(getRecruitmentSettingsStart.type,getRecruitmentSettingsSaga);
}
